<a (click)="$event.stopPropagation()" [href]="phone | libPhoneNumber: 'RFC3966'">
    {{ phone | libPhoneNumber }}
</a>
